import axiosInstance from "../middlewares/axiosInstance";
import {
  EligibleUsersResponse,
  ModuleAdmins,
  ModuleAdminsResponse,
  UpdateModuleAdminsResponse,
} from "../modules/business-admin/pages/UserManagement/UserManagement.interface";

export interface Role {
  _id?: string;
  role_name: string;
  description?: string;
  module: string;
  permissions: string[];
  is_active?: boolean;
  created_at?: number;
  created_by?: {
    name: string;
    email: string;
  };
}

export interface RoleListParams {
  pageIndex?: number;
  pageSize?: number;
  module?: string;
  searchTerm?: string;
}

export interface RoleListResponse {
  success: boolean;
  data: {
    data: Role[];
    metadata: {
      total: {
        value: number;
        relation: string;
      };
      took: number;
      timed_out: boolean;
      max_score: number;
    };
  };
}

export interface CreateRoleRequest {
  role_name: string;
  description?: string;
  module: string;
  permissions: string[];
}

export interface UpdateRoleRequest {
  _id: string;
  role_name?: string;
  description?: string;
  permissions?: string[];
}

export interface RoleResponse {
  success: boolean;
  data?: Role;
  message?: string;
}

export const userManagementService = {
  async getModuleAdmins(storeId: string): Promise<ModuleAdminsResponse> {
    const response = await axiosInstance.post(
      "/business-admin/module-admins/get",
      {
        store_id: storeId,
      }
    );
    return response.data;
  },

  async getEligibleUsers(storeId: string): Promise<EligibleUsersResponse> {
    const response = await axiosInstance.post(
      "/business-admin/module-admins/eligible-users",
      {
        store_id: storeId,
      }
    );
    return response.data;
  },

  async updateModuleAdmins(
    storeId: string,
    moduleAdmins: ModuleAdmins
  ): Promise<UpdateModuleAdminsResponse> {
    const response = await axiosInstance.post(
      "/business-admin/module-admins/update",
      {
        store_id: storeId,
        module_admins: moduleAdmins,
      }
    );
    return response.data;
  },

  // Role Management Methods
  async listRoles(params: RoleListParams): Promise<RoleListResponse> {
    const response = await axiosInstance.post(
      "/business-admin/permissions/roles/list",
      {
        pageIndex: params.pageIndex || 0,
        pageSize: params.pageSize || 10,
        module: params.module,
        searchTerm: params.searchTerm,
      }
    );
    return response.data;
  },

  async createRole(data: CreateRoleRequest): Promise<RoleResponse> {
    const response = await axiosInstance.post(
      "/business-admin/permissions/roles/create",
      data
    );
    return response.data;
  },

  async updateRole(data: UpdateRoleRequest): Promise<RoleResponse> {
    const response = await axiosInstance.post(
      "/business-admin/permissions/roles/update",
      data
    );
    return response.data;
  },

  async getRole(id: string): Promise<RoleResponse> {
    const response = await axiosInstance.post(
      "/business-admin/permissions/roles/get",
      { _id: id }
    );
    return response.data;
  },

  async deleteRole(id: string): Promise<RoleResponse> {
    const response = await axiosInstance.post(
      "/business-admin/permissions/roles/delete",
      { _id: id }
    );
    return response.data;
  },
};
